import { isAxiosError } from 'axios'

export type ErrorKind = 'chunk' | 'network' | 'unexpected'

const chunkMessagePrefixes = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS for',
]

const failedFetchMessages = [
  'Failed to fetch',
  'NetworkError when attempting to fetch resource.',
  'Load failed',
]

function isChunkError(error: unknown) {
  return (
    error instanceof Error &&
    chunkMessagePrefixes.some((prefix) => error.message.startsWith(prefix))
  )
}

function isFailedFetch(error: unknown) {
  return (
    error instanceof TypeError && failedFetchMessages.includes(error.message)
  )
}

export function classifyError(error: unknown): ErrorKind {
  if (isChunkError(error)) return 'chunk'
  if (isFailedFetch(error) || (isAxiosError(error) && !error.response)) {
    return 'network'
  }
  return 'unexpected'
}
